import { render, staticRenderFns } from "./CantidadDespachos.vue?vue&type=template&id=4bbde663&scoped=true"
import script from "./CantidadDespachos.vue?vue&type=script&lang=js"
export * from "./CantidadDespachos.vue?vue&type=script&lang=js"
import style0 from "./CantidadDespachos.vue?vue&type=style&index=0&id=4bbde663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbde663",
  null
  
)

export default component.exports